import React from "react";
import { motion } from "framer-motion";
import {
  FaLock,
  FaUserShield,
  FaFileAlt,
  FaClock,
  FaEnvelope,
} from "react-icons/fa";

const PrivacyPolicy = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-pink-100 flex justify-center items-center p-6"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1549924231-f129b911e442?auto=format&fit=crop&w=1470&q=80')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="bg-white bg-opacity-90 backdrop-blur-xl rounded-3xl shadow-2xl max-w-4xl w-full p-10 overflow-y-auto"
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="flex justify-center mb-6">
          <FaLock className="text-5xl text-indigo-600 animate-pulse" />
        </div>
        <h1 className="text-4xl font-bold text-center text-indigo-700 mb-6">
          Privacy Policy
        </h1>

        <p className="mb-4 text-gray-700 text-center">
          Welcome to <span className="font-semibold">Vicademics</span>, an
          educational platform where instructors share courses as videos,
          articles, and quizzes. Learners can purchase these courses with access
          valid for one year.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaUserShield /> Information We Collect
        </motion.h2>
        <p className="mb-4 text-gray-700">
          We collect your name, email, and payment info during registration. We
          also gather data about your course activity, progress, and preferences
          to improve your learning experience.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaFileAlt /> How We Use Your Information
        </motion.h2>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>Provide and improve our educational services.</li>
          <li>Process transactions and manage one-year course access.</li>
          <li>Communicate important updates and course information.</li>
          <li>Maintain compliance with policies and security standards.</li>
        </ul>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaUserShield /> Data Sharing and Disclosure
        </motion.h2>
        <p className="mb-4 text-gray-700">
          We never sell or rent your information. We may share data with trusted
          partners for platform operation, payment processing, or legal
          requirements.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaLock /> Security
        </motion.h2>
        <p className="mb-4 text-gray-700">
          We use industry-standard security measures to protect your data.
          However, no method is 100% secure online.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaUserShield /> Your Rights
        </motion.h2>
        <p className="mb-4 text-gray-700">
          You can access, update, or delete your personal info anytime. You may
          also opt out of promotional emails.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaClock /> Course Access and Validity
        </motion.h2>
        <p className="mb-4 text-gray-700">
          All purchased courses remain accessible for one year after purchase.
          Renewals are required to continue access beyond one year.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaFileAlt /> Changes to This Policy
        </motion.h2>
        <p className="mb-4 text-gray-700">
          We may update this Privacy Policy occasionally. Please review it
          regularly to stay informed.
        </p>

        <motion.h2 className="text-2xl font-semibold mt-6 mb-2 flex items-center gap-2 text-indigo-600">
          <FaEnvelope /> Contact Us
        </motion.h2>
        <p className="mb-6 text-gray-700">
          For any questions, contact us at{" "}
          <a
            href="mailto:support@Vicademics.com"
            className="text-indigo-600 underline"
          >
            support@Vicademics.com
          </a>
          .
        </p>

        <p className="text-center text-gray-500 text-sm">
          Last updated: June 2025
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;
